import { useTranslate } from 'react-admin';

export const useApartmentStates = () => {
	const t = useTranslate();

	const apartmentStates = [
		{ id: 1, name: t('form.fields.options.concrete') },
		{ id: 2, name: t('form.fields.options.developerBase') },
		{
			id: 3,
			name: t('form.fields.options.renovation')
		},
		{ id: 4, name: t('form.fields.options.designerRenovation') }
	];

	const getApartmentState = (id: string) =>
		apartmentStates.find(s => s.id === Number(id));

	return { apartmentStates, getApartmentState };
};
